 <!--促销组件-->
<template>
  <div class="content" v-if="cardBodyConf && cardBodyConf.length>0">
    <div class="spanclass">
      <span>{{constant.cxname}}</span>
    </div>
    <div class="child-content" v-for="(cardBodyConfig,index) in cardBodyConf" :key="index">
      <!-- 更多 -->
      <a
        v-if="cardBodyConfig.cardOption.moreUrl"
        target="_blank"
        :href="cardBodyConfig.cardOption.moreUrl"
      >
        {{constant.more}}
        <img class="imgmore" src="img/more.png" />
      </a>
      <div class="card-body-container">
        <!--左侧图片-->
        <div class="picture">
          <img :src="cardBodyConfig.cardOption.leftImg" />
        </div>
        <!--右侧商品组轮播-->
        <div class="right">
          <div class="mal-swiper">
            <swiper :options="swiperOptions[index]">
              <swiperSlide v-for="(goods,index) in cardBodyConfig.goodsGroup" :key="index">
                <!-- 促销商品展示 -->
                <ProductCard :items="goods"></ProductCard>
              </swiperSlide>
            </swiper>
          </div>
          <div class="pagination-bar">
            <div class="swiper-pagination" :id="'cbp'+index"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import ProductCard from "./ProductCard.vue";
export default {
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    ProductCard: ProductCard
  },
  data() {
    let swiperOptionArr = [];
    let autoplayObject = false;
    let cardBodyConf = this.$store.state.malMainPageConfig.cardBody;
    for (var i = 0; i < cardBodyConf.length; i++) {
      swiperOptionArr[i] = {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: autoplayObject,
        speed: cardBodyConf[i].cardOption.speed,
        pagination: {
          el: "#cbp" + i,
          clickable: true,
          renderBullet: function(index, className) {
            return (
              '<span class="' +
              className +
              '" style="margin: 0 5px; width: 25px;height:3px;background: #5e80eb;border-radius: 9px;outline:none"></span>'
            );
          }
        }
      };
    }
    return {
      swiperOptions: swiperOptionArr,
      constant: this.$store.state.malMainPageConfig.constant
    };
  },
  computed: {
    cardBodyConf: function() {
      return this.$store.state.malMainPageConfig.cardBody;
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #f5f5f5;
}
.content .spanclass {
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 24px;
  color: #333333;
  margin-top: 40px;
  float: left;
}
.content .child-content {
  margin-top: 24px;
}
.content .child-content a {
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
  text-decoration: none;
  color: #666666;
  float: right;
  font-size: 14px;
}
.card-body-container {
  display: flex;
  width: 1200px;
  justify-content: flex-start;
  align-items: center;
}
.card-body-container .picture {
  width: 196px;
  height: 349px;
  z-index: 1;
}
.card-body-container .picture img {
  width: 196px;
  height: 349px;
  z-index: 1;
}
.card-body-container .right {
  width: 1000px;
  height: 349px;
  background: #ffffff60;
}
.right .swiper-pagination {
  left: 0;
  width: 970px;
  position: relative;
}
.right .mal-swiper {
  width: 1000px;
  height: 349px;
}
.pagination-bar {
  height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  bottom: 5px;
  position: relative;
  margin-left: 860px;
  margin-top: -25px;
}
.imgmore {
  vertical-align: middle;
  margin-top: -2px;
}
</style>
